// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list[data-v-60bbd572] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.list > div[data-v-60bbd572] {\n  width: 70px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.list > div i[data-v-60bbd572] {\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
